import React from 'react';
import Modal from '@cp/src/components/Modal/Modal';
import { Typography } from '@navi/web-ui/lib/primitives';
import styles from './ProofImageModal.module.scss';
import { getSourceLabel } from '../../Addresses/contants';

interface ProofImageModalProps {
  isOpen: boolean;
  onClose: () => void;
  proofOfSourceUrl: string;
  source: string;
}

const ProofImageModal: React.FC<ProofImageModalProps> = ({
  isOpen,
  onClose,
  proofOfSourceUrl,
  source
}) => {
  const renderContent = () => {
    if (proofOfSourceUrl) {
      return <img src={proofOfSourceUrl} alt="Address proof" className={styles.proofImage} />;
    }

    return (
      <div className={styles.noImage}>
        <Typography variant="p3" color="var(--grayscale-content-2)">
          No proof image available
        </Typography>
      </div>
    );
  };

  return (
    <Modal visible={isOpen} onClose={onClose} header={getSourceLabel(source)} showCloseIcon>
      <div className={styles.imageContainer}>{renderContent()}</div>
    </Modal>
  );
};

export default ProofImageModal;
